module.exports = __webpack_public_path__ + "static/img/video_s_bg.9a577d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/video_s_bg.png
// module id = ji+N
// module chunks = 1